"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const useClickOutside_1 = __importDefault(require("../hooks/useClickOutside"));
const labelMap = {
    Mark: "Registreringsmerke",
    AircraftModelCategory: "Kategori",
    AircraftName: "Type",
    Manufacturer: "Produsent",
    Operator: "Operatør",
    MainOwner: "Eier",
    RegistrationDate: "Registreringsdato",
};
const FilterSort = (props) => {
    const [value, setValue] = (0, react_1.useState)(props.default);
    const [expanded, setExpanded] = (0, react_1.useState)(false);
    const fakeSelectRef = (0, react_1.useRef)(null);
    (0, useClickOutside_1.default)(fakeSelectRef, () => {
        setExpanded(false);
    });
    const changeValue = (val) => {
        let newValue = val;
        setValue(newValue);
        props.changeFilter("pulldown", {
            value: newValue,
        });
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: (0, classnames_1.default)("m-filter-sort", "m-filter-container", {
            expanded: expanded,
        }), ref: fakeSelectRef, children: [(0, jsx_runtime_1.jsxs)("button", { onClick: () => {
                    setExpanded(!expanded);
                }, children: [(0, jsx_runtime_1.jsx)("div", { className: "m-filter-label", children: props.label }), (0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)("m-filter-arrow", {
                            "m-filter-arrow-expanded": expanded,
                        }), children: (0, jsx_runtime_1.jsx)("svg", { width: "13", height: "10", viewBox: "0 0 13 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: (0, jsx_runtime_1.jsx)("path", { d: "M7.07038 9.67428C7.0785 9.66228 7.08175 9.64628 7.08988 9.63428L12.7624 1.92005C13.0792 1.48604 13.0792 0.782022 12.7624 0.34801C12.7591 0.34401 12.7559 0.34201 12.7526 0.34001C12.6099 0.127288 12.3983 0.00287717 12.1742 0H0.827556C0.599309 0.00453972 0.384457 0.133472 0.240971 0.35201L0.237721 0.34801C-0.0792405 0.799406 -0.0792405 1.46866 0.237721 1.92005L5.92321 9.67428C6.06645 9.88096 6.27608 10 6.49679 10C6.7175 10 6.92713 9.88096 7.07038 9.67428Z" }) }) })] }), expanded && ((0, jsx_runtime_1.jsxs)("div", { className: (0, classnames_1.default)("m-filter-body", { expanded: expanded }), children: [(0, jsx_runtime_1.jsxs)("div", { className: "title-and-close", children: ["Sorter etter", (0, jsx_runtime_1.jsxs)("a", { className: "a-close", href: "#", onClick: (ev) => {
                                    ev.preventDefault();
                                    setExpanded(!expanded);
                                }, children: [(0, jsx_runtime_1.jsx)("span", {}), (0, jsx_runtime_1.jsx)("span", {})] })] }), (0, jsx_runtime_1.jsx)("ul", { children: props.data &&
                            props.data.map((el, i) => {
                                return ((0, jsx_runtime_1.jsx)("li", { children: (0, jsx_runtime_1.jsx)("a", { className: value && value.indexOf(el) > -1 ? "selected" : "", href: "#", onClick: (ev) => {
                                            ev.preventDefault();
                                            changeValue(el);
                                            setExpanded(false);
                                        }, children: labelMap[el] }) }, i));
                            }) }), (0, jsx_runtime_1.jsx)("div", { className: "buttons", children: (0, jsx_runtime_1.jsx)("div", { className: "close-button", children: (0, jsx_runtime_1.jsx)("a", { href: "#", onClick: (ev) => {
                                    ev.preventDefault();
                                    setExpanded(!expanded);
                                }, children: "Lukk" }) }) })] }))] }));
};
exports.default = FilterSort;
